import { render, staticRenderFns } from "./TodoItem.vue?vue&type=template&id=02c1844e&scoped=true"
import script from "./TodoItem.vue?vue&type=script&lang=js"
export * from "./TodoItem.vue?vue&type=script&lang=js"
import style0 from "./TodoItem.vue?vue&type=style&index=0&id=02c1844e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c1844e",
  null
  
)

export default component.exports